import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `BadgeRoot`
};

export function useBadgeStyles() {
  const { palette, effects, fonts } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          backgroundColor: palette.themeLight,
          color: palette.neutralPrimary,
          borderRadius: effects.roundedCorner4,
          boxShadow: effects.elevation4,
          lineHeight: `24px`,
          textAlign: `center`,
          minWidth: `24px`,
          height: `24px`,
          ...fonts.tiny
        }
      ]
    }),
    [palette, effects, fonts]
  );
}
